import React, { Component } from "react";
import {
  Button,
  Grid,
  Form,
  Icon,
  Image,
  Message,
  Segment
} from "semantic-ui-react";

import orderBy from "lodash/orderBy";
import ReactTable from "react-table";
import request from "../../utils/request";
import { baseUrl } from "../../utils/constants";

const requestData = (eventId, pageSize, page, sorted, filtered) => {
  return request
    .get(this, `api:/event/void-requests/${eventId}?ts=${Date.now()}`, {})
    .then(response => {
      // handle success
      let filteredData = response;
      // You can use the filters in your request, but you are responsible for applying them.
      if (filtered.length) {
        filteredData = filtered.reduce((filteredSoFar, nextFilter) => {
          return filteredSoFar.filter(row => {
            return (row[nextFilter.id] + "").includes(nextFilter.value);
          });
        }, filteredData);
      }
      // You can also use the sorting in your request, but again, you are responsible for applying it.
      const sortedData = orderBy(
        filteredData,
        sorted.map(sort => {
          return row => {
            if (row[sort.id] === null || row[sort.id] === undefined) {
              return -Infinity;
            }
            return typeof row[sort.id] === "string"
              ? row[sort.id].toLowerCase()
              : row[sort.id];
          };
        }),
        sorted.map(d => (d.desc ? "desc" : "asc"))
      );
      // You must return an object containing the rows of the current page, and optionally the total pages number.
      const res = {
        rows: sortedData.slice(pageSize * page, pageSize * page + pageSize),
        pages: Math.ceil(filteredData.length / pageSize)
      };
      return res;
    })
    .catch(error => {
      // handle error
      return error;
    });
};

class VoidsTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      pages: null,
      loaded: false,
      eventId: this.props.match.params.id,
      expanded: {},
      errorShow: false,
      errorMessage: ""
    };
    this.fetchData = this.fetchData.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }
  componentDidMount = () => { };
  componentDidUpdate = prevProps => {
    // Typical usage (don't forget to compare props):
    if (this.props.eventId !== prevProps.eventId) {
      this.setState({
        data: [],
        pages: null,
        loaded: false,
        eventId: this.props.eventId
      });
    }
  };
  fetchData = (state, instance) => {
    this.setState({
      loaded: false,
      pageSize: state.pageSize,
      page: state.page,
      sorted: state.sorted,
      filtered: state.filtered
    });
    requestData(
      this.state.eventId,
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      this.setState({
        data: res.rows,
        pages: res.pages,
        loaded: true
      });
    });
  };
  handleChange = (e, { name, value }) => this.setState({ [name]: value });
  handleSubmit = e => {
    e.preventDefault();
    let id = e.target.getAttribute("id").replace("void", "");
    this.setState({ formLoading: true });
    var self = this;
    var payload = {
      id: id,
      eventId: this.state.eventId,
      number: this.state.number,
      action: this.state.status
    };
    return request
      .put(this, `api:/event/void-requests/${id}`, payload)
      .then(result => {
        self.setState({ formLoading: false });
        if (!result.success) {
          self.setState({
            errorShow: true,
            errorMessage: result.message
          });
          return;
        }
        if (typeof result !== "undefined") {
          self.setState({
            number: "",
            status: "",
            errorShow: false,
            errorMessage: "",
            successShow: true,
            successMessage: result.message,
            expanded: false
          }, () => setTimeout(() => { this.setState({ expanded: {} }) }, 1000));
          self.fetchData({
            sorted: [],
            page: 0,
            pageSize: 100,
            expanded: {},
            resized: [],
            filtered: []
          });
        }
      });
  };
  handleVoids = e => {
    e.preventDefault();
    this.setState({ formLoading: true });
    var self = this;
    var payload = {
      eventId: this.state.eventId
    };

    return request
      .post(this, "api:/event/void-requests", payload)
      .then(result => {
        self.setState({ formLoading: false });
        if (!result.success) {
          self.setState({
            errorShow: true,
            errorMessage: result.message
          });
        }
        if (typeof result !== "undefined") {
          self.setState({
            number: "",
            status: "",
            errorShow: false,
            errorMessage: "",
            successShow: true,
            successMessage: result.message,
            expanded: false
          }, () => setTimeout(() => { this.setState({ expanded: {} }) }, 1000));
          self.fetchData({
            sorted: [],
            page: 0,
            pageSize: 100,
            expanded: {},
            resized: [],
            filtered: []
          });
        }
      });
  };
  render() {
    const { errorShow, errorMessage, data, pages, loaded } = this.state;
    const columns = [
      {
        expander: true,
        Header: () => <strong>More</strong>,
        width: 65,
        Expander: ({ isExpanded, ...rest }) => (
          <div>
            {isExpanded ? (
              <Icon name="caret down" />
            ) : (
                <Icon name="caret right" />
              )}
          </div>
        ),
        style: {
          cursor: "pointer",
          fontSize: 25,
          padding: "0",
          textAlign: "center",
          userSelect: "none"
        }
      },
      {
        Header: "Requested on",
        accessor: "request_date"
      },
      {
        Header: "Ticket #",
        accessor: "number"
      },
      {
        Header: "Status",
        accessor: "status"
      }
    ];

    return (
      <Segment basic>
        <Segment basic clearing textAlign="right">
          <Button onClick={this.handleVoids}>Confirm Voids</Button>
        </Segment>

        <ReactTable
          data={data}
          columns={columns}
          className="-striped -highlight"
          manual
          expanded={this.state.expanded}
          onExpandedChange={(newExpanded, index, event) => {
            if (this.state.expanded === false) {
              newExpanded = {}
            }
            if (newExpanded[index[0]] === false) {
              newExpanded = {}
            }
            else {
              Object.keys(newExpanded).map(k => {
                newExpanded[k] = parseInt(k) === index[0] ? {} : false;
                return newExpanded;
              })
            }
            this.setState({
              number: "",
              status: "approve",
              errorShow: false,
              errorMessage: []
            });
            this.setState({ expanded: newExpanded });
          }}
          pages={pages} // Display the total number of pages
          loading={!loaded} // Display the loading overlay when we need it
          onFetchData={this.fetchData} // Request new data when things change
          resizable={true}
          defaultPageSize={100}
          minRows={0}
          SubComponent={row => {
            let src = row.original.path;
            let number = row.original.number;
            if (this.state.number) number = this.state.number;
            if (number === null) number = "";
            let status = row.original.status;
            if (this.state.status) status = this.state.status;
            if (status === null) status = "";
            let disabled = false;
            if (row.original.status !== "new" && row.original.status !== "skipped") disabled = true;
            return (
              <Segment basic>
                <Grid columns="equal">
                  <Grid.Column>
                    <Image src={src} fluid />
                  </Grid.Column>
                  <Grid.Column>
                    <Message negative hidden={!errorShow}>
                      <p>{errorMessage}</p>
                    </Message>
                    <Form
                      id={"void" + row.original.id}
                      onSubmit={this.handleSubmit}
                    >
                      <Form.Input
                        placeholder="Ticket #"
                        name={"number"}
                        value={number}
                        onChange={this.handleChange}
                        disabled={disabled}
                      />
                      <Form.Group inline>
                        <Form.Radio
                          name={"status"}
                          label="Approve"
                          value="approved"
                          checked={
                            status === "approved" || status === "approve"
                          }
                          onChange={this.handleChange}
                          disabled={disabled}
                        />
                        <Form.Radio
                          name={"status"}
                          label="Decline"
                          value="declined"
                          checked={
                            status === "declined" || status === "decline"
                          }
                          onChange={this.handleChange}
                          disabled={disabled}
                        />
                        <Form.Radio
                          name={"status"}
                          label="Skip"
                          value="skipped"
                          checked={status === "skipped" || status === "skip"}
                          onChange={this.handleChange}
                          disabled={disabled}
                        />
                      </Form.Group>
                      <Form.Button primary disabled={disabled}>
                        Submit
                      </Form.Button>
                    </Form>
                  </Grid.Column>
                </Grid>
              </Segment>
            );
          }}
        />
      </Segment>
    );
  }
}

export default VoidsTab;
